import React from 'react'
import { UseFormRegisterReturn, FieldValues, Path } from 'react-hook-form'

import { FieldWrapper, validationRules } from '..'
import { CheckboxGroupFieldProps } from './CheckboxGroupField.types'

import styles from './styles.module.scss'

export const CheckboxGroupField = <TFormValues extends Record<string, unknown> = Record<string, unknown>>(
  props: CheckboxGroupFieldProps<TFormValues>,
) => {
  const { label, name, register, required } = props

  return (
    <Component
      {...props}
      registration={{
        ...register(name, {
          validate: {
            atLeastOne: (value) => {
              if (required && !value) {
                return validationRules.requiredSelect(label)
              }
              return true
            },
          },
        }),
      }}
    />
  )
}

type ComponentProps<TFormValues extends FieldValues> = Omit<CheckboxGroupFieldProps<TFormValues>, 'register'> & {
  className?: string
  registration: Partial<UseFormRegisterReturn<Path<TFormValues>>>
}

const Component = <TFormValues extends Record<string, unknown>>(props: ComponentProps<TFormValues>) => (
  <FieldWrapper
    label={props.label}
    error={props.error}
    isRequired={props.required}
    column={props.column}
    labelClassName={props.labelClassName}
    fieldClassName={props.fieldClassName}
  >
    <div className={styles.wrapper}>
      {props.options.map((option) => (
        <div className={styles.inner} key={option.value}>
          <input
            className={styles.checkbox}
            type="checkbox"
            {...props.registration}
            value={option.value}
            disabled={props.disabled}
          />
          <label className={styles.label}>{option.label}</label>
        </div>
      ))}
    </div>
  </FieldWrapper>
)
